import { X } from 'lucide-react';
import { cn } from '../../../lib/cn';
import type { EtichettaScelta } from '../../../lib/email/automationService';
import type { Partenza } from '../../../lib/email/partenzaSequenza';
import { ASPETTO_PASSI } from './aspettoPassi';
import { SceltaPartenza } from './SceltaPartenza';
import { SceltaTipoSequenza } from './SceltaTipoSequenza';

interface PannelloPartenzaProps {
  partenza: Partenza;
  servizio: boolean;
  liste: EtichettaScelta[];
  onChange: (partenza: Partenza) => void;
  onCambiaServizio: (servizio: boolean) => void;
  onChiudi: () => void;
}

/**
 * Il pannello che si apre scegliendo "Si parte": qui si cambia da dove
 * entrano i contatti, finche' la sequenza e' spenta.
 */
export function PannelloPartenza({
  partenza,
  servizio,
  liste,
  onChange,
  onCambiaServizio,
  onChiudi,
}: PannelloPartenzaProps) {
  const aspetto = ASPETTO_PASSI.inizio;
  const Icona = aspetto.icona;

  return (
    <aside className="absolute inset-y-0 right-0 z-10 w-full sm:w-[340px] lg:static flex-shrink-0 border-l border-neutral-200 bg-white overflow-y-auto shadow-[-8px_0_24px_rgba(0,0,0,0.06)] lg:shadow-none">
      <div className="flex items-start gap-3 p-4 border-b border-neutral-100">
        <div className={cn('w-10 h-10 flex items-center justify-center flex-shrink-0', aspetto.pieno)}>
          <Icona className="w-5 h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-neutral-900">Si parte</p>
          <p className="text-xs text-neutral-500 leading-relaxed mt-0.5">
            Cosa manda, chi ci entra e quando.
          </p>
        </div>
        <button
          type="button"
          onClick={onChiudi}
          aria-label="Chiudi il pannello"
          className="w-8 h-8 -mr-1 -mt-1 flex items-center justify-center text-neutral-400 hover:text-neutral-900 hover:bg-neutral-100 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="p-4 space-y-4">
        <SceltaTipoSequenza servizio={servizio} onChange={onCambiaServizio} />
        <SceltaPartenza valore={partenza} liste={liste} servizio={servizio} onChange={onChange} />
      </div>
    </aside>
  );
}
